import React from "react";
import SEO from "@/components/SEO";
import ServiceLocationTemplate from "@/components/ServiceLocationTemplate";

const CraigieburnEmergencyDentistPage = () => (
  <ServiceLocationTemplate suburbName="Craigieburn" suburbSlug="craigieburn" variant="emergency-dentist" />
);

export default CraigieburnEmergencyDentistPage;
